/** Feature flags por workspace — Structura Market (commercial pass 2026-06). */

export const TENANT_PRODUCT_FLAG_KEYS = [
  "pesaje_module",
  "produccion_b2b",
  "multi_location",
  "custom_branding",
  "exports_csv",
  "analytics_advanced",
  "widget_embed",
  "whatsapp_notify",
  "pwa_install",
  "invoicing_tusfacturas",
  "invoicing_afip_direct",
  "payment_mercadopago",
  "variants_addons",
  "customer_accounts",
  "loyalty_points",
  "gift_cards",
  "digital_products",
  "integrations_gtm",
  "integrations_tiktok_pixel",
  "integrations_hotjar",
  "integrations_google_ads",
  "integrations_google_shopping",
  "integrations_pinterest_tag",
  "integrations_merchant",
  "operations_suppliers",
  "payment_config",
  "inventory_advanced",
  "product_tags",
  "bulk_prices",
  "price_lists",
  "shelf_labels",
  "payment_pos_mode",
  "payment_pos_offline",
  "inventory_bom",
  "dine_in_tables",
  "table_reservations",
  "supply_chain",
  "discount_coupons",
  "promotions_engine",
  "events_tickets",
  "custom_domain",
  "billing_lemon",
  "payment_payway",
  "payment_partial",
  "payment_marketplace_ready",
  "payment_modo",
  "shipping_shipnow",
  "shipping_tracking",
  "treggo_shipping",
  "andreani_shipping",
  "enviopack_shipping",
  "oca_epak_shipping",
  "correo_argentino_shipping",
  "cabify_shipping",
  "uber_direct_shipping",
  "delivery_provider_pedidosya",
  "delivery_provider_rapiboy",
  "delivery_provider_shipnow",
  "delivery_tracking",
  "delivery_quotes",
  "delivery_webhooks",
  "delivery_dispatch",
  "delivery_pickup",
  "delivery_eta",
  "zipnova_shipping",
  "pickit_shipping",
  "shipping_multi_carrier",
  "payment_getnet",
  "payment_uala",
  "payment_dlocal",
  "payment_nave",
  "payment_talo",
  "payment_sipago",
  "payment_qr",
  "payment_links",
  "payment_recurring",
  "payment_refunds",
  "events_qr_validator",
  "media",
  "catalog_public",
  "orders_online",
  "stock_management",
  "feature_presets",
  "institutional_orders",
  "payment_online",
  "push_notifications",
  "email_automations",
  "combos",
  "thermal_printing",
  "api_keys",
  "integrations_meta",
  "integrations_ga4",
  "integrations_clarity",
  "custom_head_scripts",
  "delivery_zones",
  "sample_data",
  "product_tours",
  "tenant_support",
  "storefront_experience",
  "composable_flows",
  "merchant_quotes",
  "lead_capture",
  // ── Commerce Growth (flag-only / upcoming) ───────────────────────────────
  "product_reviews",
  "discount_wheel",
  "abandoned_cart_incentives",
  "referral_rewards",
  "social_proof",
  "loyalty_tiers",
  "growth_campaigns",
  // ── Hardware Integration Platform (HIP) ──────────────────────────────────
  "hardware",
  "hardware_pos",
  "hardware_fiscal",
  "hardware_scale",
  "hardware_barcode",
  "hardware_qr",
  "hardware_rfid",
  "hardware_printer",
  "hardware_labels",
  "hardware_cashdrawer",
  "hardware_customer_display",
  "digital_signage",
  "picking_app",
  "mcp_ai_connected",
  "hardware_payment_terminal",
  "hardware_data_collector",
  "hardware_kitchen",
  "hardware_nfc",
  "hardware_usb",
  "hardware_bluetooth",
  "hardware_serial",
  "hardware_network",
  "hardware_custom_drivers",
  "hardware_multi_device",
  "hardware_monitoring",
  // ── Renata — Asistente operativo IA ─────────────────────────────────────────
  "ai_assistant",
  // ── Legal + KYC — switch de plataforma para pruebas (SCRUM-33) ──────────────
  "legal_kyc_gate",
  "service_bookings",
  "booking_widget",
  "service_site_builder",
  "professionals",
  "session_packs",
  "waitlist",
  "intake_forms",
  "service_reviews",
  "commissions",
  "calendar_sync",
] as const;

export type TenantProductFlagKey = (typeof TENANT_PRODUCT_FLAG_KEYS)[number];

export const TENANT_PRODUCT_FLAG_DEFAULTS: Record<TenantProductFlagKey, boolean> = {
  pesaje_module: false,
  produccion_b2b: false,
  multi_location: false,
  custom_branding: false,
  exports_csv: false,
  analytics_advanced: false,
  widget_embed: false,
  whatsapp_notify: false,
  pwa_install: false,
  invoicing_tusfacturas: false,
  invoicing_afip_direct: false,
  payment_mercadopago: false,
  variants_addons: false,
  customer_accounts: false,
  loyalty_points: false,
  gift_cards: false,
  digital_products: false,
  integrations_gtm: false,
  integrations_tiktok_pixel: false,
  integrations_hotjar: false,
  integrations_google_ads: false,
  integrations_google_shopping: false,
  integrations_pinterest_tag: false,
  integrations_merchant: false,
  operations_suppliers: false,
  payment_config: false,
  inventory_advanced: false,
  product_tags: false,
  bulk_prices: false,
  price_lists: false,
  shelf_labels: false,
  payment_pos_mode: false,
  payment_pos_offline: false,
  inventory_bom: false,
  dine_in_tables: false,
  table_reservations: false,
  supply_chain: false,
  discount_coupons: false,
  promotions_engine: false,
  events_tickets: false,
  custom_domain: false,
  billing_lemon: false,
  payment_payway: false,
  payment_partial: false,
  payment_marketplace_ready: false,
  payment_modo: false,
  shipping_shipnow: false,
  shipping_tracking: false,
  treggo_shipping: false,
  andreani_shipping: false,
  enviopack_shipping: false,
  oca_epak_shipping: false,
  correo_argentino_shipping: false,
  cabify_shipping: false,
  uber_direct_shipping: false,
  delivery_provider_pedidosya: false,
  delivery_provider_rapiboy: false,
  delivery_provider_shipnow: false,
  delivery_tracking: false,
  delivery_quotes: false,
  delivery_webhooks: false,
  delivery_dispatch: false,
  delivery_pickup: false,
  delivery_eta: false,
  zipnova_shipping: false,
  pickit_shipping: false,
  shipping_multi_carrier: false,
  payment_getnet: false,
  payment_uala: false,
  payment_dlocal: false,
  payment_nave: false,
  payment_talo: false,
  payment_sipago: false,
  payment_qr: false,
  payment_links: false,
  payment_recurring: false,
  payment_refunds: false,
  events_qr_validator: false,
  media: false,
  catalog_public: true,
  orders_online: true,
  stock_management: true,
  feature_presets: true,
  institutional_orders: false,
  payment_online: true,
  push_notifications: false,
  email_automations: false,
  combos: false,
  composable_flows: false,
  merchant_quotes: false,
  lead_capture: false,
  product_reviews: false,
  discount_wheel: false,
  abandoned_cart_incentives: false,
  referral_rewards: false,
  social_proof: false,
  loyalty_tiers: false,
  growth_campaigns: false,
  thermal_printing: false,
  api_keys: false,
  integrations_meta: false,
  integrations_ga4: false,
  integrations_clarity: false,
  custom_head_scripts: false,
  delivery_zones: false,
  sample_data: true,
  product_tours: true,
  tenant_support: true,
  storefront_experience: true,
  // ── Hardware Integration Platform (HIP) — default off, se activa por plan ──
  hardware: false,
  hardware_pos: false,
  hardware_fiscal: false,
  hardware_scale: false,
  hardware_barcode: false,
  hardware_qr: false,
  hardware_rfid: false,
  hardware_printer: false,
  hardware_labels: false,
  hardware_cashdrawer: false,
  hardware_customer_display: false,
  digital_signage: false,
  picking_app: false,
  mcp_ai_connected: false,
  hardware_payment_terminal: false,
  hardware_data_collector: false,
  hardware_kitchen: false,
  hardware_nfc: false,
  hardware_usb: false,
  hardware_bluetooth: false,
  hardware_serial: false,
  hardware_network: false,
  hardware_custom_drivers: false,
  hardware_multi_device: false,
  hardware_monitoring: false,
  ai_assistant: false,
  legal_kyc_gate: false,
  service_bookings: false,
  booking_widget: false,
  service_site_builder: false,
  professionals: false,
  session_packs: false,
  waitlist: false,
  intake_forms: false,
  service_reviews: false,
  commissions: false,
  calendar_sync: false,
};

export const TENANT_PRODUCT_FLAG_META: Record<TenantProductFlagKey, string> = {
  pesaje_module: "Módulo de pesaje (productos por kg)",
  produccion_b2b: "B2B / Mayorista (canales, portal y pedidos institucionales)",
  multi_location: "Múltiples sucursales / puntos de retiro",
  custom_branding: "Tema y colores personalizados",
  exports_csv: "Exportar pedidos y datos",
  analytics_advanced: "Métricas avanzadas + embudo nativo storefront",
  widget_embed: "Widget embebible /widget/:slug",
  whatsapp_notify: "WhatsApp API (Kapso BYO)",
  pwa_install: "PWA — instalar app (service worker + prompt)",
  invoicing_tusfacturas: "Facturación electrónica AFIP/ARCA (TusFacturasAPP)",
  invoicing_afip_direct: "Facturación AFIP/ARCA directo (certificado CUIT, WSAA/WSFE/CAEA)",
  payment_mercadopago: "MercadoPago BYO",
  variants_addons: "Variantes de producto y extras/addons",
  customer_accounts: "Cuentas de clientes B2C",
  loyalty_points: "Programa de puntos",
  gift_cards: "Gift cards",
  digital_products: "Productos digitales y descargas",
  integrations_gtm: "Google Tag Manager (GTM)",
  integrations_tiktok_pixel: "TikTok Pixel",
  integrations_hotjar: "Hotjar (heatmaps y grabaciones)",
  integrations_google_ads: "Google Ads Conversion Tracking",
  integrations_google_shopping: "Feed Google Shopping (Merchant Center)",
  integrations_pinterest_tag: "Pinterest Tag",
  integrations_merchant: "Merchant — Personalización (estampados/bordados)",
  operations_suppliers: "Proveedores y órdenes de compra",
  payment_config: "Configuración financiera — cuentas bancarias, métodos de pago y dispositivos de cobro",
  inventory_advanced: "Historial de movimientos y devoluciones de stock",
  product_tags: "Etiquetas de producto",
  bulk_prices: "Ajuste masivo de precios",
  price_lists: "Listas de precios múltiples",
  shelf_labels: "Etiquetas de góndola y cartelería promocional",
  payment_pos_mode: "POS / Cobro en mostrador con sesión de caja",
  payment_pos_offline: "POS offline — venta en efectivo sin conexión con sincronización diferida",
  inventory_bom: "Escandallos — ingredientes y recetas (BOM)",
  dine_in_tables: "Mesas QR — gestión de salón y comanda",
  table_reservations: "Reservas de mesa — turnos y disponibilidad online",
  supply_chain: "Supply Chain — proveedores, OC, lotes FEFO",
  discount_coupons: "Cupones de descuento",
  promotions_engine: "Promociones automáticas (NxM)",
  events_tickets: "Eventos con cupos y tickets QR",
  custom_domain: "Usá tu propio dominio (ej: tienda.tuempresa.com) en lugar del subdominio Structu",
  billing_lemon: "Gestioná tu plan y facturación directamente desde el panel",
  payment_payway: "Gateway Payway/Decidir: débito y crédito con tokenización segura",
  payment_partial: "Cobrá una seña o monto parcial del pedido",
  payment_marketplace_ready: "Distribución de pagos a múltiples comercios (próximamente)",
  payment_modo: "Pagos con MODO — QR y deeplink",
  shipping_shipnow: "Conectá tu cuenta Shipnow para cotizar y despachar pedidos",
  shipping_tracking: "Seguimiento de envíos y descarga de etiquetas PDF",
  treggo_shipping: "Conectá tu cuenta Treggo para crear y rastrear envíos desde los pedidos",
  cabify_shipping: "Cabify Logistics: envío inmediato y same day",
  uber_direct_shipping: "Uber Direct: courier on-demand (pickup → dropoff)",
  delivery_provider_pedidosya: "PedidosYa Delivery (Partner POS / mock Fase 1)",
  delivery_provider_rapiboy: "Rapiboy última milla / same-day (mock Fase 1)",
  delivery_provider_shipnow: "ShipNow como delivery provider (alias hub)",
  delivery_tracking: "Tracking unificado de deliveries",
  delivery_quotes: "Cotización de deliveries en checkout",
  delivery_webhooks: "Ingesta de webhooks de delivery providers",
  delivery_dispatch: "Despacho / asignación de courier",
  delivery_pickup: "Retiro por courier en local",
  delivery_eta: "ETA de deliveries en ops y storefront",
  zipnova_shipping: "Zipnova: cotizá y despachá multi-carrier",
  pickit_shipping: "Pickit: puntos de retiro y envíos a domicilio",
  correo_argentino_shipping: "Conectá Correo Argentino (MiCorreo) para cotizar e importar envíos",
  oca_epak_shipping: "Conectá OCA ePak para cotizar, crear y etiquetar envíos nacionales",
  andreani_shipping: "Conectá tu cuenta Andreani para cotizar, crear y rastrear envíos desde los pedid",
  enviopack_shipping: "Cotizá y despachá vía Enviopack (multi-carrier nacional)",
  shipping_multi_carrier: "Multi-carrier: cotizar y comparar envíos en checkout",
  payment_getnet: "Gateway Getnet (Santander) — checkout web",
  payment_uala: "Checkout con link de pago Ualá Bis (tarjeta débito/crédito)",
  payment_dlocal: "Checkout multi-país LatAm con dLocal Go",
  payment_nave: "Nave Negocios — QR y tarjetas via red Galicia/Naranja X (Ranty)",
  payment_talo: "Talo — Cobros en cripto (BTC, USDT, Pix)",
  payment_sipago: "Sipago — Checkout con tarjetas via Geopagos",
  payment_qr: "Cobrá escaneando un QR generado por el comercio",
  payment_links: "Generá links de cobro para enviar a tus clientes",
  payment_recurring: "Débito automático mensual con tarjeta tokenizada — próximamente",
  payment_refunds: "Reembolsos totales y parciales desde el panel",
  events_qr_validator: "Escáner de cámara para validar tickets en la entrada del evento — evita sobreven",
  media: "Media Library",
  catalog_public: "Catálogo público / storefront",
  orders_online: "Pedidos online",
  stock_management: "Gestión de stock",
  feature_presets: "Presets de experiencia / onboarding",
  institutional_orders: "Pedidos institucionales B2B",
  payment_online: "Pagos online (umbrella providers)",
  push_notifications: "Push notifications (OneSignal)",
  email_automations: "Automatizaciones de email marketing/ops",
  combos: "Combos de productos",
  composable_flows: "Bundles",
  merchant_quotes: "Cotizaciones personalizadas por producto (indumentaria / moda)",
  lead_capture: "Captura de emails / leads en storefront",
  product_reviews: "Reseñas de productos en storefront",
  discount_wheel: "Ruleta de descuentos en storefront",
  abandoned_cart_incentives: "Incentivos por carrito abandonado",
  referral_rewards: "Programa de referidos con recompensas",
  social_proof: "Prueba social en storefront (compras recientes, stock)",
  loyalty_tiers: "Niveles de fidelización (bronce, plata, oro)",
  growth_campaigns: "Campañas de growth (promos temporales y embudos)",
  thermal_printing: "Impresión térmica / QZ Tray",
  api_keys: "API keys headless",
  integrations_meta: "Meta Pixel",
  integrations_ga4: "Google Analytics 4",
  integrations_clarity: "Microsoft Clarity",
  custom_head_scripts: "Scripts custom en <head>",
  delivery_zones: "Zonas de delivery (CP, localidad, provincia, área) o rangos por km",
  sample_data: "Datos de muestra / seed demo",
  product_tours: "Tours y ayuda in-app",
  tenant_support: "Soporte in-app",
  storefront_experience: "Editor de experiencia storefront",
  hardware: "Hardware Integration Platform — dispositivos POS conectados",
  hardware_pos: "Terminal POS dedicada (Android/Windows)",
  hardware_fiscal: "Controlador fiscal (AFIP/ARCA)",
  hardware_scale: "Balanza inteligente (peso en vivo o etiquetadora)",
  hardware_barcode: "Escáner de código de barras (USB/Bluetooth/industrial)",
  hardware_qr: "Lector de códigos QR",
  hardware_rfid: "Lector RFID",
  hardware_printer: "Impresora térmica",
  hardware_labels: "Impresora de etiquetas",
  hardware_cashdrawer: "Cajón monedero",
  hardware_customer_display: "Display / visor para el cliente",
  digital_signage: "Digital Signage — menu boards y pantallas al público",
  picking_app: "Structura Picking — PWA de preparación de pedidos y recepciones por QR",
  mcp_ai_connected: "IA conectada (MCP) — ChatGPT, Claude o Gemini trabajando con los datos del negocio",
  hardware_payment_terminal: "Terminal de pago con tarjeta/QR",
  hardware_data_collector: "Colector de datos / pistola industrial",
  hardware_kitchen: "Kitchen Display System",
  hardware_nfc: "Lector NFC",
  hardware_usb: "Conexión de dispositivos por USB",
  hardware_bluetooth: "Conexión de dispositivos por Bluetooth",
  hardware_serial: "Conexión de dispositivos por puerto serie/COM",
  hardware_network: "Conexión de dispositivos por red (IP)",
  hardware_custom_drivers: "Drivers de hardware personalizados (Enterprise)",
  hardware_multi_device: "Gestión de múltiples dispositivos por sucursal (Enterprise)",
  hardware_monitoring: "Monitoreo de estado y diagnóstico de hardware (Enterprise)",
  ai_assistant: "Renata — Asistente operativo con IA (conversacional, Skills, aprobación de acciones)",
  legal_kyc_gate: "Legal + KYC — habilita aceptación de documentos legales y verificación de identidad (Didit) para este tenant",
  service_bookings: "Turnos de servicio (agenda y reservas)",
  booking_widget: "Widget de reserva de turnos",
  service_site_builder: "Sitio de marca con bloques de servicios",
  professionals: "Profesionales y horarios",
  session_packs: "Packs de sesiones",
  waitlist: "Lista de espera con reclamo por token",
  intake_forms: "Formularios previos al turno",
  service_reviews: "Reseñas post-turno",
  commissions: "Liquidaciones a profesionales",
  calendar_sync: "Sync Google Calendar / Zoom",
};

export const TENANT_PRODUCT_FLAG_PLAN_TIER: Record<
  TenantProductFlagKey,
  "starter" | "pro" | "business" | "enterprise"
> = {
  pesaje_module: "starter",
  widget_embed: "starter",
  payment_mercadopago: "starter",
  digital_products: "starter",
  multi_location: "pro",
  whatsapp_notify: "pro",
  pwa_install: "pro",
  invoicing_tusfacturas: "pro",
  invoicing_afip_direct: "pro",
  exports_csv: "pro",
  analytics_advanced: "pro",
  variants_addons: "pro",
  customer_accounts: "pro",
  loyalty_points: "pro",
  gift_cards: "pro",
  custom_branding: "pro",
  integrations_gtm: "pro",
  integrations_tiktok_pixel: "pro",
  integrations_hotjar: "pro",
  integrations_google_ads: "pro",
  integrations_google_shopping: "business",
  integrations_pinterest_tag: "pro",
  integrations_merchant: "pro",
  produccion_b2b: "business",
  operations_suppliers: "pro",
  payment_config: "pro",
  inventory_advanced: "pro",
  product_tags: "pro",
  bulk_prices: "pro",
  price_lists: "business",
  shelf_labels: "pro",
  payment_pos_mode: "business",
  payment_pos_offline: "business",
  inventory_bom: "business",
  dine_in_tables: "business",
  table_reservations: "business",
  supply_chain: "business",
  discount_coupons: "pro",
  promotions_engine: "pro",
  events_tickets: "starter",
  custom_domain: "pro",
  billing_lemon: "starter",
  payment_payway: "pro",
  payment_partial: "pro",
  payment_marketplace_ready: "business",
  payment_modo: "pro",
  shipping_shipnow: "pro",
  shipping_tracking: "pro",
  treggo_shipping: "pro",
  andreani_shipping: "pro",
  enviopack_shipping: "pro",
  oca_epak_shipping: "pro",
  correo_argentino_shipping: "pro",
  cabify_shipping: "pro",
  uber_direct_shipping: "pro",
  delivery_provider_pedidosya: "pro",
  delivery_provider_rapiboy: "pro",
  delivery_provider_shipnow: "pro",
  delivery_tracking: "pro",
  delivery_quotes: "pro",
  delivery_webhooks: "pro",
  delivery_dispatch: "pro",
  delivery_pickup: "pro",
  delivery_eta: "pro",
  zipnova_shipping: "pro",
  pickit_shipping: "pro",
  shipping_multi_carrier: "business",
  payment_getnet: "pro",
  payment_uala: "pro",
  payment_dlocal: "pro",
  payment_nave: "pro",
  payment_talo: "pro",
  payment_sipago: "pro",
  payment_qr: "pro",
  payment_links: "starter",
  payment_recurring: "pro",
  payment_refunds: "starter",
  events_qr_validator: "starter",
  media: "starter",
  catalog_public: "starter",
  orders_online: "starter",
  stock_management: "starter",
  feature_presets: "starter",
  institutional_orders: "business",
  payment_online: "starter",
  push_notifications: "pro",
  email_automations: "pro",
  combos: "pro",
  composable_flows: "pro",
  merchant_quotes: "pro",
  lead_capture: "pro",
  product_reviews: "pro",
  discount_wheel: "pro",
  abandoned_cart_incentives: "pro",
  referral_rewards: "pro",
  social_proof: "pro",
  loyalty_tiers: "business",
  growth_campaigns: "pro",
  thermal_printing: "pro",
  api_keys: "business",
  integrations_meta: "pro",
  integrations_ga4: "pro",
  integrations_clarity: "pro",
  custom_head_scripts: "business",
  delivery_zones: "pro",
  sample_data: "starter",
  product_tours: "starter",
  tenant_support: "starter",
  storefront_experience: "starter",
  hardware: "pro",
  hardware_pos: "business",
  hardware_fiscal: "business",
  hardware_scale: "business",
  hardware_barcode: "pro",
  hardware_qr: "pro",
  hardware_rfid: "business",
  hardware_printer: "pro",
  hardware_labels: "business",
  hardware_cashdrawer: "business",
  hardware_customer_display: "business",
  digital_signage: "business",
  picking_app: "business",
  mcp_ai_connected: "pro",
  hardware_payment_terminal: "business",
  hardware_data_collector: "business",
  hardware_kitchen: "business",
  hardware_nfc: "business",
  hardware_usb: "pro",
  hardware_bluetooth: "pro",
  hardware_serial: "business",
  hardware_network: "business",
  hardware_custom_drivers: "enterprise",
  hardware_multi_device: "enterprise",
  hardware_monitoring: "enterprise",
  ai_assistant: "pro",
  legal_kyc_gate: "starter",
  service_bookings: "starter",
  booking_widget: "starter",
  service_site_builder: "pro",
  professionals: "pro",
  session_packs: "pro",
  waitlist: "pro",
  intake_forms: "pro",
  service_reviews: "pro",
  commissions: "pro",
  calendar_sync: "business",
};

export type PlanTemplate = "starter" | "pro" | "business" | "enterprise";

/** Extraído para poder reusarlo como base del template "enterprise" (= business + HIP avanzado). */
const BUSINESS_FLAG_TEMPLATE: Record<TenantProductFlagKey, boolean> = {
  pesaje_module: true,
  produccion_b2b: true,
  multi_location: true,
  custom_branding: true,
  exports_csv: true,
  analytics_advanced: true,
  widget_embed: true,
  whatsapp_notify: true,
  invoicing_tusfacturas: true,
  invoicing_afip_direct: true,
  pwa_install: true,
  payment_mercadopago: true,
  variants_addons: true,
  customer_accounts: true,
  loyalty_points: true,
  gift_cards: true,
  digital_products: true,
  integrations_gtm: true,
  integrations_tiktok_pixel: true,
  integrations_hotjar: true,
  integrations_google_ads: true,
  integrations_google_shopping: true,
  integrations_pinterest_tag: true,
  integrations_merchant: true,
  operations_suppliers: true,
  payment_config: true,
  inventory_advanced: true,
  product_tags: true,
  bulk_prices: true,
  price_lists: true,
  shelf_labels: true,
  payment_pos_mode: true,
  payment_pos_offline: false,
  inventory_bom: true,
  dine_in_tables: true,
  table_reservations: true,
  supply_chain: true,
  discount_coupons: true,
  promotions_engine: true,
  events_tickets: true,
  custom_domain: false,
  billing_lemon: false,
  payment_payway: true,
  payment_partial: true,
  payment_marketplace_ready: false,
  payment_modo: true,
  shipping_shipnow: true,
  shipping_tracking: true,
  treggo_shipping: true,
  andreani_shipping: true,
  enviopack_shipping: true,
  oca_epak_shipping: true,
  correo_argentino_shipping: true,
  cabify_shipping: true,
  uber_direct_shipping: true,
  delivery_provider_pedidosya: true,
  delivery_provider_rapiboy: true,
  delivery_provider_shipnow: true,
  delivery_tracking: true,
  delivery_quotes: true,
  delivery_webhooks: true,
  delivery_dispatch: true,
  delivery_pickup: true,
  delivery_eta: true,
  zipnova_shipping: true,
  pickit_shipping: true,
  shipping_multi_carrier: true,
  payment_getnet: true,
  payment_uala: true,
  payment_dlocal: true,
  payment_nave: false,
  payment_talo: false,
  payment_sipago: false,
  payment_qr: true,
  payment_links: true,
  payment_recurring: false,
  payment_refunds: true,
  events_qr_validator: true,
  media: true,
  catalog_public: true,
  orders_online: true,
  stock_management: true,
  feature_presets: true,
  institutional_orders: true,
  payment_online: true,
  push_notifications: true,
  email_automations: true,
  combos: true,
  composable_flows: true,
  merchant_quotes: true,
  lead_capture: true,
  product_reviews: true,
  discount_wheel: true,
  abandoned_cart_incentives: true,
  referral_rewards: true,
  social_proof: true,
  loyalty_tiers: true,
  growth_campaigns: true,
  thermal_printing: true,
  api_keys: true,
  integrations_meta: true,
  integrations_ga4: true,
  integrations_clarity: true,
  custom_head_scripts: true,
  delivery_zones: true,
  sample_data: true,
  product_tours: true,
  tenant_support: true,
  storefront_experience: true,
  hardware: true,
  hardware_pos: true,
  hardware_fiscal: true,
  hardware_scale: true,
  hardware_barcode: true,
  hardware_qr: true,
  hardware_rfid: true,
  hardware_printer: true,
  hardware_labels: true,
  hardware_cashdrawer: true,
  hardware_customer_display: true,
  digital_signage: true,
  picking_app: true,
  mcp_ai_connected: true,
  hardware_payment_terminal: true,
  hardware_data_collector: true,
  hardware_kitchen: true,
  hardware_nfc: true,
  hardware_usb: true,
  hardware_bluetooth: true,
  hardware_serial: true,
  hardware_network: true,
  hardware_custom_drivers: false,
  hardware_multi_device: false,
  hardware_monitoring: false,
  ai_assistant: true,
  legal_kyc_gate: false,
  service_bookings: true,
  booking_widget: true,
  service_site_builder: true,
  professionals: true,
  session_packs: true,
  waitlist: true,
  intake_forms: true,
  service_reviews: true,
  commissions: true,
  calendar_sync: true,
};

export const PLAN_FLAG_TEMPLATES: Record<PlanTemplate, Record<TenantProductFlagKey, boolean>> = {
  starter: {
    pesaje_module: true,
    produccion_b2b: false,
    multi_location: false,
    custom_branding: false,
    exports_csv: false,
    analytics_advanced: false,
    widget_embed: true,
    whatsapp_notify: false,
    invoicing_tusfacturas: false,
    invoicing_afip_direct: false,
    pwa_install: false,
    payment_mercadopago: false,
    variants_addons: false,
    customer_accounts: false,
    loyalty_points: false,
    gift_cards: false,
    digital_products: true,
    integrations_gtm: false,
    integrations_tiktok_pixel: false,
    integrations_hotjar: false,
    integrations_google_ads: false,
    integrations_google_shopping: false,
    integrations_pinterest_tag: false,
    integrations_merchant: false,
    operations_suppliers: false,
    payment_config: false,
    inventory_advanced: false,
    product_tags: false,
    bulk_prices: false,
    price_lists: false,
    shelf_labels: false,
    payment_pos_mode: false,
    payment_pos_offline: false,
    inventory_bom: false,
    dine_in_tables: false,
    table_reservations: false,
    supply_chain: false,
    discount_coupons: false,
    promotions_engine: false,
    events_tickets: false,
    custom_domain: false,
    billing_lemon: false,
    payment_payway: false,
    payment_partial: false,
    payment_marketplace_ready: false,
    payment_modo: false,
    shipping_shipnow: false,
    shipping_tracking: false,
    treggo_shipping: false,
    andreani_shipping: false,
    enviopack_shipping: false,
  oca_epak_shipping: false,
  correo_argentino_shipping: false,
    cabify_shipping: false,
    uber_direct_shipping: false,
    delivery_provider_pedidosya: false,
    delivery_provider_rapiboy: false,
    delivery_provider_shipnow: false,
    delivery_tracking: false,
    delivery_quotes: false,
    delivery_webhooks: false,
    delivery_dispatch: false,
    delivery_pickup: false,
    delivery_eta: false,
    zipnova_shipping: false,
    pickit_shipping: false,
    shipping_multi_carrier: false,
    payment_getnet: false,
    payment_uala: false,
    payment_dlocal: false,
    payment_nave: false,
    payment_talo: false,
    payment_sipago: false,
    payment_qr: false,
    payment_links: false,
    payment_recurring: false,
    payment_refunds: false,
    events_qr_validator: false,
    media: true,
    catalog_public: true,
    orders_online: true,
    stock_management: true,
    feature_presets: true,
    institutional_orders: false,
    payment_online: true,
    push_notifications: false,
    email_automations: false,
    combos: false,
    thermal_printing: false,
    api_keys: false,
    integrations_meta: false,
    integrations_ga4: false,
    integrations_clarity: false,
    custom_head_scripts: false,
    delivery_zones: false,
    sample_data: true,
    product_tours: true,
    tenant_support: true,
    storefront_experience: true,
    composable_flows: false,
    merchant_quotes: false,
    lead_capture: false,
    product_reviews: false,
    discount_wheel: false,
    abandoned_cart_incentives: false,
    referral_rewards: false,
    social_proof: false,
    loyalty_tiers: false,
    growth_campaigns: false,
    hardware: false,
    hardware_pos: false,
    hardware_fiscal: false,
    hardware_scale: false,
    hardware_barcode: false,
    hardware_qr: false,
    hardware_rfid: false,
    hardware_printer: false,
    hardware_labels: false,
    hardware_cashdrawer: false,
    hardware_customer_display: false,
    digital_signage: false,
    picking_app: false,
    mcp_ai_connected: false,
    hardware_payment_terminal: false,
    hardware_data_collector: false,
    hardware_kitchen: false,
    hardware_nfc: false,
    hardware_usb: false,
    hardware_bluetooth: false,
    hardware_serial: false,
    hardware_network: false,
    hardware_custom_drivers: false,
    hardware_multi_device: false,
    hardware_monitoring: false,
    ai_assistant: false,
    legal_kyc_gate: false,
    service_bookings: true,
    booking_widget: true,
    service_site_builder: false,
    professionals: false,
    session_packs: false,
    waitlist: false,
    intake_forms: false,
    service_reviews: false,
    commissions: false,
    calendar_sync: false,
  },
  pro: {
    pesaje_module: true,
    produccion_b2b: false,
    multi_location: true,
    custom_branding: true,
    exports_csv: true,
    analytics_advanced: true,
    widget_embed: true,
    whatsapp_notify: true,
    invoicing_tusfacturas: true,
    invoicing_afip_direct: true,
    pwa_install: true,
    payment_mercadopago: false,
    variants_addons: true,
    customer_accounts: true,
    loyalty_points: true,
    gift_cards: true,
    digital_products: true,
    integrations_gtm: true,
    integrations_tiktok_pixel: true,
    integrations_hotjar: true,
    integrations_google_ads: true,
    integrations_google_shopping: false,
    integrations_pinterest_tag: true,
    integrations_merchant: true,
    operations_suppliers: true,
    payment_config: true,
    inventory_advanced: true,
    product_tags: true,
    bulk_prices: true,
    price_lists: false,
    shelf_labels: true,
    payment_pos_mode: false,
    payment_pos_offline: false,
    inventory_bom: false,
    dine_in_tables: false,
    table_reservations: false,
    supply_chain: false,
    discount_coupons: true,
    promotions_engine: true,
    events_tickets: true,
    custom_domain: false,
    billing_lemon: false,
    payment_payway: true,
    payment_partial: true,
    payment_marketplace_ready: false,
    payment_modo: true,
    shipping_shipnow: true,
    shipping_tracking: true,
    treggo_shipping: true,
    andreani_shipping: true,
    enviopack_shipping: true,
  oca_epak_shipping: true,
  correo_argentino_shipping: true,
    cabify_shipping: true,
    uber_direct_shipping: true,
    delivery_provider_pedidosya: true,
    delivery_provider_rapiboy: true,
    delivery_provider_shipnow: true,
    delivery_tracking: true,
    delivery_quotes: true,
    delivery_webhooks: true,
    delivery_dispatch: true,
    delivery_pickup: true,
    delivery_eta: true,
    zipnova_shipping: true,
    pickit_shipping: true,
    shipping_multi_carrier: false,
    payment_getnet: true,
    payment_uala: true,
    payment_dlocal: true,
    payment_nave: false,
    payment_talo: false,
    payment_sipago: false,
    payment_qr: true,
    payment_links: false,
    payment_recurring: false,
    payment_refunds: false,
    events_qr_validator: true,
    media: true,
    catalog_public: true,
    orders_online: true,
    stock_management: true,
    feature_presets: true,
    institutional_orders: false,
    payment_online: true,
    push_notifications: true,
    email_automations: true,
    combos: true,
    thermal_printing: true,
    api_keys: false,
    integrations_meta: true,
    integrations_ga4: true,
    integrations_clarity: true,
    custom_head_scripts: false,
    delivery_zones: true,
    sample_data: true,
    product_tours: true,
    tenant_support: true,
    storefront_experience: true,
    composable_flows: true,
    merchant_quotes: true,
    lead_capture: true,
    product_reviews: true,
    discount_wheel: true,
    abandoned_cart_incentives: true,
    referral_rewards: true,
    social_proof: true,
    loyalty_tiers: false,
    growth_campaigns: true,
    hardware: true,
    hardware_pos: false,
    hardware_fiscal: false,
    hardware_scale: false,
    hardware_barcode: true,
    hardware_qr: true,
    hardware_rfid: false,
    hardware_printer: true,
    hardware_labels: false,
    hardware_cashdrawer: false,
    hardware_customer_display: false,
    digital_signage: false,
    picking_app: false,
    mcp_ai_connected: true,
    hardware_payment_terminal: false,
    hardware_data_collector: false,
    hardware_kitchen: false,
    hardware_nfc: false,
    hardware_usb: true,
    hardware_bluetooth: true,
    hardware_serial: false,
    hardware_network: false,
    hardware_custom_drivers: false,
    hardware_multi_device: false,
    hardware_monitoring: false,
    ai_assistant: true,
    legal_kyc_gate: false,
    service_bookings: true,
    booking_widget: true,
    service_site_builder: true,
    professionals: true,
    session_packs: true,
    waitlist: true,
    intake_forms: true,
    service_reviews: true,
    commissions: true,
    calendar_sync: false,
  },
  business: BUSINESS_FLAG_TEMPLATE,
  // Enterprise = plan superior: todas las keys del catálogo en true.
  enterprise: {
    ...BUSINESS_FLAG_TEMPLATE,
    custom_domain: true,
    billing_lemon: true,
    payment_marketplace_ready: true,
    payment_nave: true,
    payment_talo: true,
    payment_sipago: true,
    payment_recurring: true,
    hardware_custom_drivers: true,
    hardware_multi_device: true,
    hardware_monitoring: true,
    api_keys: true,
    custom_head_scripts: true,
    hardware_pos: true,
    hardware_fiscal: true,
    hardware_scale: true,
    hardware_rfid: true,
    hardware_labels: true,
    hardware_cashdrawer: true,
    hardware_customer_display: true,
    hardware_payment_terminal: true,
    hardware_data_collector: true,
    hardware_kitchen: true,
    hardware_nfc: true,
    hardware_serial: true,
    hardware_network: true,
  },
};


/** Mapea planId de suscripción → plantilla de flags (free_trial/trial = pro). */
export function planIdToFlagTemplate(planId: string | null | undefined): PlanTemplate {
  const id = (planId ?? "").toLowerCase();
  if (id === "enterprise") return "enterprise";
  if (id === "business") return "business";
  // `trial` = id de sesión self-service; `free_trial` = plan de suscripción post-approve
  if (id === "pro" || id === "team" || id === "free_trial" || id === "trial") return "pro";
  return "starter";
}

/**
 * Flags efectivos del workspace.
 * - Base: plantilla del plan contratado (source of truth).
 * - stored[key]===true: grant extra (más allá del plan).
 * - stored[key]===false: NO revoca una feature del plan (snapshots viejos al
 *   upgradear dejaban false y desgobernaban Business/Enterprise). Para apagar
 *   una feature del plan usá featureOverrides globales o por tenant en true-deny
 *   vía catálogo admin (enabled=false).
 */
export function resolveEffectiveTenantProductFlags(
  planId: string | null | undefined,
  stored: Record<string, boolean> | null | undefined,
): Record<TenantProductFlagKey, boolean> {
  const out = { ...PLAN_FLAG_TEMPLATES[planIdToFlagTemplate(planId)] };
  if (!stored) return out;
  for (const key of TENANT_PRODUCT_FLAG_KEYS) {
    if (stored[key] === true) out[key] = true;
  }
  return out;
}

/**
 * Rematerializa product_flags al cambiar de plan (admin workspace / billing).
 * - Base: plantilla del nuevo plan (source of truth del snapshot).
 * - Preserva keys fuera del catálogo (p.ej. is_demo).
 * - NO toca feature_overrides (extras intencionales por tenant viven ahí).
 * - NO conserva true "de plan viejo" en product_flags: un downgrade debe apagar
 *   features del plan anterior; grants puntuales van en feature_overrides.
 */
export function materializeTenantProductFlagsForPlan(
  planId: string | null | undefined,
  current: Record<string, boolean> | null | undefined,
): Record<string, boolean> {
  const out: Record<string, boolean> = {
    ...PLAN_FLAG_TEMPLATES[planIdToFlagTemplate(planId)],
  };
  if (!current) return out;
  const catalog = new Set<string>(TENANT_PRODUCT_FLAG_KEYS);
  for (const [k, v] of Object.entries(current)) {
    if (!catalog.has(k) && typeof v === "boolean") out[k] = v;
  }
  return out;
}

export function mergeTenantProductFlags(
  stored: Record<string, boolean> | null | undefined,
): Record<TenantProductFlagKey, boolean> {
  const out = { ...TENANT_PRODUCT_FLAG_DEFAULTS };
  if (!stored) return out;
  for (const key of TENANT_PRODUCT_FLAG_KEYS) {
    if (typeof stored[key] === "boolean") out[key] = stored[key];
  }
  return out;
}


/** Mapeo config.tracking.*Enabled → flag de producto (solo las que tienen flag en catalog). */
export const TRACKING_CONFIG_FLAG_MAP = {
  gtmEnabled: "integrations_gtm",
  tiktokEnabled: "integrations_tiktok_pixel",
  hotjarEnabled: "integrations_hotjar",
  googleAdsEnabled: "integrations_google_ads",
  pinterestEnabled: "integrations_pinterest_tag",
  ga4Enabled: "integrations_ga4",
  clarityEnabled: "integrations_clarity",
  customHeadEnabled: "custom_head_scripts",
  metaPixelId: "integrations_meta",
} as const satisfies Record<string, TenantProductFlagKey>;

/**
 * Anula toggles de tracking cuyo product flag está off.
 * No borra IDs guardados — solo evita inyección/activación en runtime.
 */
export function filterTrackingByProductFlags(
  tracking: Record<string, unknown> | null | undefined,
  flags: Record<string, boolean> | null | undefined,
): Record<string, unknown> {
  const src = { ...(tracking ?? {}) };
  const merged = mergeTenantProductFlags(flags as Record<string, boolean> | null | undefined);
  for (const [enabledKey, flagKey] of Object.entries(TRACKING_CONFIG_FLAG_MAP)) {
    if (!merged[flagKey as TenantProductFlagKey]) {
      // booleans off; IDs (metaPixelId) null para no inyectar
      src[enabledKey] = enabledKey.endsWith("Id") || enabledKey.endsWith("Html") ? null : false;
    }
  }
  return src;
}

/** True si el patch intenta activar un tracker cuyo flag está off. */
export function trackingPatchRequiresFlag(
  trackingPatch: Record<string, unknown> | null | undefined,
): TenantProductFlagKey[] {
  if (!trackingPatch || typeof trackingPatch !== "object") return [];
  const needed: TenantProductFlagKey[] = [];
  for (const [enabledKey, flagKey] of Object.entries(TRACKING_CONFIG_FLAG_MAP)) {
    if (trackingPatch[enabledKey] === true) needed.push(flagKey as TenantProductFlagKey);
  }
  return needed;
}
